import React from "react";
import styles from "./Modal.module.css";
const UIModal = ({ header, body, isOpen, closeModal, isImage = false }) => {
  return (
    <div
      id="overlay-test"
      className={`${styles["overlay"]} ${
        styles[isOpen !== "null" ? (isOpen ? "openModal" : "closeModal") : ""]
      }`}
      onClick={(event) => {
        if (event.target.id === "overlay-test") {
          closeModal();
        }
      }}
    >
      <div
        className={styles["modal"]}
        style={{
          padding: isImage ? "10px" : "30px",
          maxHeight: isImage ? "" : "80vh",
        }}
      >
        <div>
          {header && (
            <header className={styles.header}>
              <h2>{header}</h2>
            </header>
          )}
          {body && body}
          {/* {body && (
            <div className={`${styles.body} ${isImage && styles.imageBody}`}>
              {body}
            </div>
          )} */}
        </div>
        {!isImage && (
          <footer className={styles.footer}>
            <button className={styles.btn} onClick={closeModal}>
              Close
            </button>
          </footer>
        )}
      </div>
    </div>
  );
};

export default UIModal;
